/* eslint-disable react/jsx-no-useless-fragment */
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import styles from "./welcomeCard.module.scss";
import WalletSvg from "./WalletSvg";
import Modalui from "../UI/modal/Modalui";
import AddFund from "../addFund/AddFund";
import { fetchUserListAction } from "src/page/dashboard/dashboardSlice";
import { checkPermission, removeNull } from "src/utils/utils";
import { useAppDispatch, useAppSelector } from "src/page/store";
import {
  CAN_ACCESS_ONBOARDING,
  CAN_ACT_ON_QUICK_LINKS,
  CAN_SEE_HOW_TO_DEPOSIT,
  PARTICIPANT,
  CORPORATE,
  INDIVIDUAL,
  CAN_CREATE_ORGANISATION,
  EMPTY_STRING
} from "../constant/constant";
import { useNavigate } from "react-router-dom";
import { setOnboardingProgress } from "src/page/onBoarding/onBoardingSlice";
import QuickLinks from "./QuickLinks";
import BusinessIcon from "@mui/icons-material/Business";
import { Menu, MenuItem } from "@mui/material";
import { OrganizationType } from "src/types/commonTypes";

interface WelcomeCardProps {
  name?: string;
}

function WelcomeCard({ name = EMPTY_STRING }: WelcomeCardProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { users, topAccounts } = useAppSelector((state) => state.dashboard);
  const { cognitoConfig } = useAppSelector((state) => state.auth);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [optinalButton, setOptionalButton] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const currentOrganisationType = topAccounts?.list?.find(
    (a) => String(a?.organisationId) === String(cognitoConfig?.currentOrganisation?.organisation_id)
  )?.type as OrganizationType;

  const handleAddFundClick = () => {
    setIsModalOpen((prev) => !prev);
  };

  useEffect(() => {
    const data = {
      limit: 20,
      from: 0,
      role: PARTICIPANT
    };

    dispatch(
      fetchUserListAction(removeNull(data), () => {
        setOptionalButton(true);
      })
    );
  }, [dispatch]);

  const handleResumeOnboarding = () => {
    dispatch(setOnboardingProgress({ onboardingProgress: "addParticipant", clickCounter: 1 }));
    navigate("/on-boarding");
  };

  const handleOrganizationTypeClick = (type: string) => {
    setAnchorEl(null);
    navigate(`/on-boarding?orgtype=${type}`);
  };

  return (
    <div className={styles.welcomeCardBox}>
      <div className={styles.welcomeMessage}>
        <div className={styles.welcomeMessageIn}>
          <h1>
            Hello <span>{name}</span>
          </h1>
          <p>Welcome to the SpendAble Budget Hub</p>
        </div>
        <div className={styles.welcomeBtn}>
          {checkPermission(CAN_SEE_HOW_TO_DEPOSIT) && (
            <div className={styles.addFund}>
              <Modalui open={isModalOpen} handleClose={handleAddFundClick} modaluiOver={styles.addFundmodaluiOver}>
                <AddFund />
              </Modalui>
              <div>
                {optinalButton && (
                  <>
                    {users.total ? (
                      <Button variant="contained" onClick={handleAddFundClick}>
                        <WalletSvg />
                        How to deposit
                      </Button>
                    ) : (
                      <>
                        {checkPermission(CAN_ACCESS_ONBOARDING) && (
                          <Button variant="contained" onClick={handleResumeOnboarding}>
                            Resume your OnBoarding
                          </Button>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
          {checkPermission(CAN_CREATE_ORGANISATION) && (
            <div className={styles.onBoardOrg}>
              <Button
                variant="contained"
                startIcon={<BusinessIcon />}
                aria-haspopup="true"
                aria-expanded={Boolean(anchorEl)}
                onClick={(e) => setAnchorEl(e.currentTarget)}
              >
                {currentOrganisationType === "REFERER" ? "Create New Account" : "OnBoard Orgnaisation"}
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => {
                  setAnchorEl(null);
                }}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#ffffff",
                    width: 163,
                    color: "#62201c"
                  },
                  "& .MuiMenuItem-root": {
                    "&:hover": {
                      border: "1px solid #62201c40",
                      background: "#62201c1f"
                    }
                  }
                }}
              >
                <MenuItem onClick={() => handleOrganizationTypeClick(CORPORATE)}>Corporate</MenuItem>
                <MenuItem onClick={() => handleOrganizationTypeClick(INDIVIDUAL)}>Individual</MenuItem>
              </Menu>
            </div>
          )}
          {optinalButton && users.total > 0 && checkPermission(CAN_ACT_ON_QUICK_LINKS) && <QuickLinks />}
        </div>
      </div>
      <hr className={styles.breakline} />
    </div>
  );
}

export default WelcomeCard;
